import { ExpiryTimeGranularity, ExpiryTimeGranularityType } from '@x-guard/xgac-types/xgac';

export type ExpiryStatus = 'valid' | 'expiring' | 'expired';

export const DEFAULT_REMINDER_PERIODS: ExpiryTimeGranularity[] = [
  { type: ExpiryTimeGranularityType.Day, value: 1 },
  { type: ExpiryTimeGranularityType.Week, value: 1 },
  { type: ExpiryTimeGranularityType.Month, value: 1 },
];

export const calculateDaysUntilDate = (date: string) => Math.floor((new Date(date).setUTCHours(23, 59, 59, 999) - Date.now()) / (1000 * 60 * 60 * 24));

export const isCertificationOrItemExpiring = (
  expiryDate: string | undefined,
  largestReminderPeriodInDays: number,
): boolean => {

  if (!expiryDate) return false;
  return calculateDaysUntilDate(expiryDate) <= largestReminderPeriodInDays;

};

export const certificationExpiryChipColor = (
  days: number,
  largestReminderPeriodInDays: number,
): 'primary' | 'warning' | 'error' => {

  if (days > largestReminderPeriodInDays) return 'primary';
  if (days <= 0) return 'error';
  return 'warning';

};

export const getCertificationExpiryText = (
  days: number,
  translate: (key: string, options?: { smart_count?: number }) => string,
) => {

  if (days === 0) {

    return translate('resources.certification-categories.text.expires_today');

  }

  if (days < 0) {

    return translate('resources.certification-categories.text.already_expired_for', {
      smart_count: Math.abs(days),
    });

  }
  return translate('resources.certification-categories.text.days_until_expiry', {
    smart_count: days,
  });

};

export const getExpiryStatus = (
  expiryDate: string,
  largestReminderPeriodInDays: number,
): 'valid' | 'expiring' | 'expired' => {

  if (calculateDaysUntilDate(expiryDate) <= 0) {

    return 'expired';

  }

  if (isCertificationOrItemExpiring(expiryDate, largestReminderPeriodInDays)) {

    return 'expiring';

  }

  return 'valid';

};
